/**
 * Widevine UUID.
 *
 * @group DRM
 *
 * @beta
 */
export const WIDEVINE_UUID = 'edef8ba9-79d6-4ace-a3c8-27dcd51d21ed';
//# sourceMappingURL=WIDEVINE_UUID.js.map